import * as Reflux from "reflux";

export const AnonCartActions = {
	addItem: Reflux.createAction(["addItem"]),
	setItemQuantity: Reflux.createAction(["setItemQuantity"]),
	setItemServiceOption: Reflux.createAction(["setItemServiceOption"]),
	deleteItem: Reflux.createAction(["deleteItem"]),
	deleteItems: Reflux.createAction(["deleteItems"]),
	deleteCart: Reflux.createAction(["deleteCart"]),
	updateItemsFilter: Reflux.createAction(["updateItemsFilter"]),
	changeSortCriterion: Reflux.createAction(["changeSortCriterion"]),
	redirectIfNotAnonymous: Reflux.createAction(["redirectIfNotAnonymous"]),
	fetchEvents: Reflux.createAction(["fetchEvents"]),
	markCartMerged: Reflux.createAction(["markCartMerged"]),
	onMergeFailed: Reflux.createAction(["onMergeFailed"]),
};
